/**
 * 在 Global 環境切換到 ACN 語系，必須要導向 ZH-CN
 */

export default defineNuxtRouteMiddleware(() => {
  const runtimeConfig = useRuntimeConfig();
  const { ENVIRONMENT, CONFIGURATION } = runtimeConfig.public;
  const { $i18n } = useNuxtApp();
  const { hostname } = useRequestURL();
  const { locale } = $i18n;
  const domain = import.meta.client ? window.location.hostname : hostname;

  if (CONFIGURATION !== 'ACN' && domain !== 'localhost') {
    if (locale.value === EnumLocale.ZH_CN) {
      const ZH_CN_PATH = (() => {
        switch (ENVIRONMENT) {
          case 'PRODUCTION':
            return `${provideDomain(EnumLocale.ZH_CN, ENVIRONMENT)}/zh-cn/marketplace`;
          case 'STAGING':
            return `${provideDomain(EnumLocale.ZH_CN, ENVIRONMENT)}/zh-cn/marketplace`;
          default:
            return `${provideDomain(EnumLocale.ZH_CN, ENVIRONMENT)}/zh-cn/marketplace`;
        }
      })();
      return navigateTo(
        { path: ZH_CN_PATH },
        { redirectCode: 301, external: true }
      );
    }
  }
});
